import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/Button';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import { useCompanyIdMaybe } from '@startuptools/common/react-wrapper';
import { useNavigate } from './Navigate';

export const NotFound = () => {
  const companyId = useCompanyIdMaybe();
  const { link, rootPath } = useNavigate();

  return (
    <Stack justifyContent="center" alignItems="center" gap={2} mt={4}>
      <Typography level="h1">
        <Trans id="404 Page Not Found" />
      </Typography>

      <Typography level="title-md">
        <Trans id="We couldn't find the page you're looking for" />
      </Typography>

      <Box>
        <Button
          component={Link}
          to={companyId ? link('/') : rootPath}
          startDecorator={<ArrowBackIcon />}
          variant="outlined"
        >
          <Trans id="Go Back" />
        </Button>
      </Box>
    </Stack>
  );
};
